import {
  hintTextStyle,
  seriesHeaderStyle,
  seriesNumberStyle,
  seriesProblemStyle,
} from '../styles'
import type { SeriesProblemDisplay } from '../types'
import { SourceIcon } from './source-icon'

interface SeriesHeaderProps {
  problems: SeriesProblemDisplay[]
  mode: 'create' | 'add'
  seriesName?: string
  canSave: boolean
  newCount?: number
}

export function SeriesHeader({
  problems,
  mode,
  seriesName,
  canSave,
  newCount = 0,
}: SeriesHeaderProps) {
  if (mode === 'create' && problems.length === 0) {
    return (
      <div style={seriesHeaderStyle}>
        <div style={{ fontWeight: 600, marginBottom: '4px' }}>
          Creating Problem Series
        </div>
        <div style={hintTextStyle}>
          Search for problems to add (type 2+ characters)
        </div>
      </div>
    )
  }

  const title =
    mode === 'create'
      ? `Series Problems (${problems.length})`
      : `${seriesName} (${problems.length} total${newCount > 0 ? `, ${newCount} new` : ''})`

  return (
    <div style={seriesHeaderStyle}>
      <div style={{ fontWeight: 600, marginBottom: '8px' }}>{title}</div>
      {problems.map((p, index) => (
        <div key={p.id} style={seriesProblemStyle}>
          <span
            style={{
              ...seriesNumberStyle,
              backgroundColor: p.isNew ? '#22c55e' : '#3b82f6',
            }}
          >
            {index + 1}
          </span>
          <SourceIcon sourceIcon={p.sourceIcon} source={p.source} />
          <span
            style={{
              fontSize: '13px',
              fontWeight: p.isNew ? 600 : 400,
            }}
          >
            {p.externalId ? `#${p.externalId} - ` : ''}
            {p.name}
            {p.isNew && (
              <span style={{ color: '#22c55e', marginLeft: '4px' }}>NEW</span>
            )}
          </span>
        </div>
      ))}
      <div style={hintTextStyle}>
        {mode === 'create'
          ? canSave
            ? 'Press ⌘+Enter to save series, or add more problems'
            : 'Add at least 2 problems to save'
          : canSave
            ? 'Press ⌘+Enter to save changes, or add more problems'
            : 'Add at least 1 problem to save'}
      </div>
    </div>
  )
}

// Selection header shown when selecting a series to add to
export function SelectSeriesHeader() {
  return (
    <div style={seriesHeaderStyle}>
      <div style={{ fontWeight: 600, marginBottom: '4px' }}>
        Select a Series
      </div>
      <div style={hintTextStyle}>Choose a series to add problems to</div>
    </div>
  )
}
